
/*
  Testimonials
*/
const initTestimonials = () => {
  document.querySelectorAll('.testimonials').forEach(section => {
    const element = section.querySelector('.splide')

    const mySplide = new Splide(element, {
      type: element.dataset.loop === 'true' ? 'loop' : 'slide',
      arrows: element.dataset.arrows === 'true',
      pagination: element.dataset.pagination === 'true',
      easing: element.dataset.easing,
      speed: Number(element.dataset.speed),
      perMove: Number(element.dataset.perMove),
      autoplay: element.dataset.autoplay === 'true',
      interval: Number(element.dataset.interval),
      per_move: Number(element.dataset.perMove),
      rewind: element.dataset.rewind === 'true',
      mediaQuery: 'min',
      breakpoints: {
        0: { perPage: Number(element.dataset.breakpointXs), padding: '10%' },
        576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
        768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
        992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
        1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
        1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
      },
      direction: document.documentElement.getAttribute('dir')
    })

    const fixArrowsPos = () => {
      const top = section.querySelector('.card').clientHeight / 2
      section.querySelectorAll('.splide__arrow').forEach(arrow => {
        arrow.style.top = `${top}px`
      })
    }

    const fixPagination = () => {
      if (window.matchMedia('(max-width: 575px').matches) {
        const pagination = section.querySelector('.splide__pagination')

        if (!pagination) return

        section.querySelector('.splide__pagination--mobile')?.remove()

        const total = pagination.querySelectorAll('button').length

        let text = element.dataset.textSlideOf.replace('[x]', mySplide.index + 1)
        text = text.replace('[total]', total)

        pagination.insertAdjacentHTML('beforebegin', `
          <div class="splide__pagination--mobile text-muted small">
            ${text}
          </div>
        `)
      }
    }

    mySplide.on('ready resize', () => {
      fixArrowsPos()
      fixPagination()
    })

    mySplide.on('move', () => {
      fixPagination()
    })

    mySplide.mount()
  })
}
initTestimonials()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.testimonials')) {
    initTestimonials()
  }
})